import { requester } from "App";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useState } from "react";

function AdminCategoryList() {
    const [list, setList] = useState();

    // 중첩된 객체 포함 모든 키를 추출하는 함수
    const extractHeaders = (data) => {
        const headersSet = new Set();
        data &&
            data.forEach(item => {
                Object.keys(item).forEach(key => {
                    if (key !== 'id') { // 'password' 키는 제외
                        if (typeof item[key] === 'object' && item[key] !== null) {
                            Object.keys(item[key]).forEach(subKey => {
                                headersSet.add(`${key}.${subKey}`);
                            });
                        } else {
                            headersSet.add(key);
                        }
                    }
                });
            });
        return Array.from(headersSet);
    };
    const headers = extractHeaders(list);

    // 중첩된 데이터 접근 함수
    const getNestedValue = (item, path) => {
        const keys = path.split('.');
        let result = item;
        for (let key of keys) {
            result = result[key];
        }
        return result;
    };

    useEffect(() => {
        let data = { storeId: "root" }
        requester.findAllCategories(data, (result) => {
            
            setList(result.data);
        })
    }, [])
    const styles = {
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            boxShadow: '0 2px 3px rgba(0, 0, 0, 0.1)',
        },
        th: {
            backgroundColor: '#f0f0f0',
            color: '#333',
            fontWeight: 'bold',
            padding: '10px',
            border: '1px solid #ccc',
            textAlign: 'left',
        },
        td: {
            padding: '8px',
            border: '1px solid #ccc',
            textAlign: 'left',
        },
    };
    return (
        <Container>
            <Container maxWidth={1200}>
        <VerticalFlex gap={30}>
            <FlexChild>
                <Center width={"100%"} textAlign={"left"}>
                <P size={40} font={"gmarketSansBold"}>카테고리 리스트</P>
                </Center>
            </FlexChild>
            <FlexChild>
            <div style={{ overflowX: 'auto' }}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            {/* 테이블 헤더 */}
                            {headers.map((header) => (
                                <th style={styles.th} key={header}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {/* 데이터 행 */}
                        {list && list.map((item, index) => (
                            <tr key={index}>
                                {headers.map((header) => (
                                    <td style={styles.td} key={`${index}-${header}`}>{getNestedValue(item, header)}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            </FlexChild>
        </VerticalFlex>
        </Container>
        </Container>
    );
}

export default AdminCategoryList;